import Container from "react-bootstrap/Container";
import { Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import config from "../config";

function Footer() {
    return (
        <>
            <section className="footer-top">
                <Container>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>Company</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/about-us"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            About Us
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Careers
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/customer-speak"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Customer Speak
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/contact-us"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Contact Us
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/become-an-instructor"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Become An Instructor
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/partner-with-us"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Partner With Us
                                        </Link>
                                    </Col>
                                </Col>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>Offerings</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link to="/" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>Live Virtual (Online)</Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link to="/" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>Classroom Training</Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/corporate"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Corporate Training
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link to="/" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>Refer and Earn</Link>
                                    </Col>
                                </Col>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>Legal</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/terms-and-conditions"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Terms and Conditions
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/privacy-policy"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Privacy Policy
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/cancellation-and-refund-policy"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Cancellation and Refund Policy
                                        </Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Link
                                            to="/complaint-handling-policy"
                                            onClick={() => {
                                                requestAnimationFrame(() => {
                                                    window.scrollTo(0, 0);
                                                });
                                            }}
                                        >
                                            Complaint Handling Policy
                                        </Link>
                                    </Col>
                                </Col>
                                <Col md={3} xs={12} className="ord2">
                                    <Row className="ft-contact mx-0">
                                        <h3>Contact Us</h3>
                                        <Col className="cnt-phone">
                                            <img
                                                src={`${config.BASE_URL}/assets/images/cnt-phone.svg`}
                                                className="img-fluid"
                                                alt="cnt-phone"
                                            />
                                            <Link to="tel:+919143964396">+91 91 4396 4396</Link>
                                        </Col>
                                        <Col className="cnt-phone">
                                            <img
                                                src={`${config.BASE_URL}/assets/images/cnt-phone.svg`}
                                                className="img-fluid"
                                                alt="cnt-phone"
                                            />
                                            <Link to="tel:+918647992999">+91 86 4799 2999</Link>
                                        </Col>
                                        <Col className="cnt-mail">
                                            <img
                                                src={`${config.BASE_URL}/assets/images/cnt-mail.png`}
                                                className="img-fluid"
                                                alt="cnt-mail"
                                            />
                                            <Link to="mailto:info@agileseekers.com">
                                                info@agileseekers.com
                                            </Link>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>Kanban</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/kanban/kanban-management-professional-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>KMP II Certification</Nav.Link>
                                    </Col>
                                </Col>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>SAFe</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/safe/leading-safe-agilist-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>SAFe Agile Certification</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/safe/safe-product-owner-product-manager-popm-certification" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>SAFe POPM Certification</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/safe/safe-scrum-master-certification" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>SAFe Scrum Master Certification</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/safe/safe-advanced-scrum-master-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>SAFe Advanced Scrum Master</Nav.Link>
                                    </Col>
                                </Col>
                                <Col md={3} sm={6} xs={12} className="ft-link">
                                    <h3>Agile Management</h3>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/agile-and-scrum/certified-agile-coach-icp-acc-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>Certified Agile Coach</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/agile-and-scrum/certified-scrum-master-csm-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>CSM Certification</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/agile-and-scrum/cspo-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>CSPO Certification</Nav.Link>
                                    </Col>
                                    <Col>
                                        <img
                                            src={`${config.BASE_URL}/assets/images/ftarrow.png`}
                                            className="img-fluid"
                                            alt="ftarrow"
                                        />
                                        <Nav.Link href="https://www.agileseekers.com/agile-and-scrum/professional-scrum-master-psm-certification-training" onClick={() => {
                                            requestAnimationFrame(() => {
                                                window.scrollTo(0, 0);
                                            });
                                        }}>PSM Certification</Nav.Link>
                                    </Col>
                                </Col>
                                <Col md={3} xs={12} className="ft-connect ord1">
                                    <Row>
                                        <Col xs={6} sm={6} md={12}>
                                            <h3>Connect With us</h3>
                                            <Col>
                                                <Link
                                                    to="https://www.linkedin.com/company/agileSeekers"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src={`${config.BASE_URL}/assets/images/linkedino.png`}
                                                        className="img-fluid"
                                                        alt="linkedin"
                                                    />
                                                </Link>
                                                <Link
                                                    to="https://www.facebook.com/agileseekers"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src={`${config.BASE_URL}/assets/images/facebooko.png`}
                                                        className="img-fluid"
                                                        alt="facebook"
                                                    />
                                                </Link>
                                                <Link
                                                    to="https://www.instagram.com/agileSeekers/"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src={`${config.BASE_URL}/assets/images/instagramo.png`}
                                                        className="img-fluid"
                                                        alt="instagram"
                                                    />
                                                </Link>
                                                <Link to="https://x.com/AgileSeekers" target="_blank">
                                                    <img
                                                        src={`${config.BASE_URL}/assets/images/twittero.png`}
                                                        className="img-fluid"
                                                        alt="twitter"
                                                    />
                                                </Link>
                                                <Link
                                                    to="https://www.youtube.com/@agileSeekers"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src={`${config.BASE_URL}/assets/images/youtubeo.png`}
                                                        className="img-fluid"
                                                        alt="youtube"
                                                    />
                                                </Link>
                                            </Col>
                                        </Col>
                                        <Col xs={6} sm={6} md={12}>
                                            <h3>WE ACCEPT</h3>
                                            <img
                                                src={`${config.BASE_URL}/assets/images/we-accept.png`}
                                                className="img-fluid we-accept"
                                                alt="we-accept"
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="ft-bottom">
                        <Col md={12}>
                            <p>
                                © 2025 Copyright AGILESEEKERS CONSULTING LLP. All Rights
                                Reserved.
                            </p>
                        </Col>
                    </Row>
                    <Link
                        to="https://api.whatsapp.com/send?phone=919143964396"
                        target="_blank"
                    >
                        <img
                            src={`${config.BASE_URL}/assets/images/wpclr.svg`}
                            className="img-fluid wpclr"
                            alt="wpclr"
                        />
                    </Link>
                </Container>
            </section>
            <section className="footer-bottom">
                <Container fluid>
                    <Row>
                        <Col xs={8} sm={6} className="fb-left">
                            <Col className="mail">
                                <img
                                    src={`${config.BASE_URL}/assets/images/cnt-phone.png`}
                                    className="img-fluid"
                                    alt="mail"
                                />
                                <Link to="">+91 91 4396 4396</Link>
                            </Col>
                        </Col>
                        <Col xs={4} sm={6} className="fb-center mx-0">
                            <Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>
                                Drop a Query
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Footer;
